import { Component } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';

export interface Report {
  name: string;
  description: string;
  link: string;
}

@Component({
  selector: 'app-report-list',
  imports: [SharedModule],
  templateUrl: './report-list.component.html',
  styleUrl: './report-list.component.scss'
})
export class ReportListComponent {
  reports: Report[] = [
    {
      name: "Todays Leads",
      description: "Displays all leads generated today, yesterday, last week, last month, and last year, providing a quick overview of lead generation performance.",
      link: "leads/todays-leads"
    },
    {
      name: "Leads by Status",
      description: "Categorizes leads based on their current status, such as New, Contacted, Qualified, or Disqualified.",
      link: "leads/leads-by-status"
    },
    {
      name: "Leads by Source",
      description: "Breaks down lead acquisition by source, such as website, social media, events, or referrals.",
      link: "leads/leads-by-source"
    },
    {
      name: "Leads by Ownership",
      description: "Organizes leads by assigned owner, allowing managers to track team performance and workload distribution.",
      link: "leads/leads-by-ownership"
    },
    {
      name: "Qualified Leads",
      description: "Shows leads that have been qualified based on specific criteria, including qualification date and assigned user.",
      link: "leads/qualified-leads"
    },
    {
      name: "Call Log Report",
      description: "Show all leads that have been called based on the selected date range and lead ownership filters.",
      link: "leads/call-log-report"
    },
    {
      name: "Email Log Report",
      description: "Show all leads that have been emailed based on the selected date range and lead ownership filters.",
      link: "leads/email-log-report"
    },
  ];

  totalReports: number = 0;
  totalCategories: number = 0;
  lastUpdated: string = '';

  constructor() { }


  getCategoryColorClass(category: string): string {
    const colorMap: { [key: string]: string } = {
      'Sales': 'category-emerald',
      'Analytics': 'category-blue',
      'Finance': 'category-purple',
      'Research': 'category-orange',
      'Product': 'category-indigo',
      'Operations': 'category-teal'
    };
    return colorMap[category] || 'category-gray';
  }

  getCardColorClass(color: string): string {
    return `card-${color}`;
  }

  onReportClick(report: Report): void {
    // Handle report click - you can navigate or open modal
    console.log('Report clicked:', report);
  }

  onLoadMoreReports(): void {
    // Handle load more functionality
    console.log('Load more reports clicked');
  }
}
